import {
  initialState,
  Actions,
  State,
  DELETE_CALENDAR,
  DELETE_CALENDAR_SUCCESS,
  DELETE_CALENDAR_ERROR,
  RESET_DELETE_CALENDAR,
} from "../../types/calendar/delete";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_CALENDAR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DELETE_CALENDAR_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DELETE_CALENDAR_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DELETE_CALENDAR:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
